import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";
import { getAbTestsSelector, getAppFeatures, getAppUser } from "../../app/appSelectors";
import { FEATURES } from "../../app/appConstants";
import { TBannerLocation } from "./banners.t";
import moment from "moment";
import { TLocationCode } from "../../app/types/appActions.t";
import { getActivePromocodes, getBonusesActiveList, getBonusesAvailableList } from "../Bonus/bonusesSelectors";
import filterBannerByDependsOn from "./utils/filterBannerByDependsOn";
import _ from "lodash";

const bannersSelectors = (state: IRootState) => state.banners;

export const getIsBannersInitedSelector = createSelector(
    bannersSelectors, tutorials => tutorials.isInited,
);

export const getIsBannersEnabledSelector = createSelector(
    getAppFeatures, features => !!features[FEATURES.BANNERS],
);

export const getBannersListSelector = createSelector(
    bannersSelectors, tutorials => tutorials.bannersList,
);

export const makeSelectGetBannerByName = (name: string) => createSelector(
    getBannersListSelector, bannersList => bannersList.find(banner => banner.name === name),
);

export const makeSelectBannersListByLocation = (location: TBannerLocation) => createSelector(
    [getBannersListSelector, getAppUser, getAppFeatures, getBonusesAvailableList, getBonusesActiveList, getAbTestsSelector, getActivePromocodes], (
        bannersList,
        user,
        features,
        availableList,
        bonusesActiveList,
        abTests,
        activePromocodesList,
    ) => {
        return _.chain(bannersList)
            .filter(banner => banner.locations?.includes(location))
            .filter(banner => !Array.isArray(banner.available_locales) || banner.available_locales.includes(user?.locale as TLocationCode))
            .filter(banner => !Array.isArray(banner.available_countries) || banner.available_countries.includes(user?.country as TLocationCode))
            .filter(banner => filterBannerByDependsOn({
                abTests,
                activePromocodesList,
                banner,
                bonusesActiveList,
                bonusesAvailableList: availableList,
                features
            }))
            .filter(banner => {
                const locationParams = banner.params?.[location];
                return !locationParams?.closed_at ||
                    moment(locationParams.closed_at).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD');
            })
            .sortBy('position')
            .value();
    }
);
